export interface ChamadoSuporte {
  id: string;
  titulo: string;
  descricao: string;
  tipo: 'suporte_tecnico' | 'financeiro' | 'duvida' | 'reclamacao';
  status: 'aberto' | 'em_andamento' | 'aguardando' | 'resolvido' | 'fechado';
  prioridade: 'baixa' | 'media' | 'alta' | 'urgente';
  usuario_tipo: 'empresa' | 'participante';
  usuario_nome: string;
  usuario_email: string;
  responsavel: string;
  canal_origem?: string; // ex: Telefone, Presencial, etc.
  data_criacao: string;
  data_atualizacao: string;
  respostas: RespostaChamado[];
}

export interface RespostaChamado {
  id: string;
  autor_nome: string;
  autor_role: string;
  mensagem: string;
  data: string;
  interna: boolean;
}

export const chamadosSuporte: ChamadoSuporte[] = [
  {
    id: 'TK-2026-0042',
    titulo: 'Não consigo resgatar meus pontos para PIX',
    descricao: 'Tento fazer o resgate de R$ 150,00 mas recebo erro "Saldo insuficiente para resgate" apesar de ter 2.500 pontos.',
    tipo: 'financeiro',
    status: 'aberto',
    prioridade: 'alta',
    usuario_tipo: 'participante',
    usuario_nome: 'João Pedro Silva',
    usuario_email: 'joao.silva@email.com',
    responsavel: 'Ana Souza',
    data_criacao: '2026-05-08T09:15:00Z',
    data_atualizacao: '2026-05-08T09:15:00Z',
    respostas: []
  },
  {
    id: 'TK-2026-0041',
    titulo: 'Empresa não aparece na lista de campanhas',
    descricao: 'Cadastrei minha empresa ontem e ainda não consigo acessar o painel de campanhas. O CNPJ é 45.678.901/0001-23.',
    tipo: 'suporte_tecnico',
    status: 'em_andamento',
    prioridade: 'media',
    usuario_tipo: 'empresa',
    usuario_nome: 'Ricardo Ferreira',
    usuario_email: 'ricardo@inovacaodigital.com.br',
    responsavel: 'Ana Souza',
    data_criacao: '2026-05-07T14:30:00Z',
    data_atualizacao: '2026-05-08T10:00:00Z',
    respostas: [
      {
        id: 'r-001',
        autor_nome: 'Ana Souza',
        autor_role: 'suporte',
        mensagem: 'Olá Ricardo! Verificamos aqui que o cadastro está pendente de aprovação. Já fizemos a liberação e você já pode acessar o painel.',
        data: '2026-05-08T10:00:00Z',
        interna: false
      }
    ]
  },
  {
    id: 'TK-2026-0040',
    titulo: 'Pontuação não creditou após venda',
    descricao: 'Realizei uma venda de R$ 2.800,00 no dia 05/05 mas os pontos ainda não apareceram no extrato do colaborador.',
    tipo: 'duvida',
    status: 'aguardando',
    prioridade: 'media',
    usuario_tipo: 'empresa',
    usuario_nome: 'Fernanda Costa',
    usuario_email: 'fernanda@techbrasil.com.br',
    responsavel: 'Mariana Lima',
    data_criacao: '2026-05-06T16:45:00Z',
    data_atualizacao: '2026-05-07T11:20:00Z',
    respostas: [
      {
        id: 'r-002',
        autor_nome: 'Mariana Lima',
        autor_role: 'operador',
        mensagem: 'Olá Fernanda! Estamos verificando a conciliação da venda. Poderia nos enviar o número do pedido?',
        data: '2026-05-07T11:20:00Z',
        interna: false
      },
      {
        id: 'r-003',
        autor_nome: 'Mariana Lima',
        autor_role: 'operador',
        mensagem: 'Nota interna: verificar integração com webhook de vendas.',
        data: '2026-05-07T11:21:00Z',
        interna: true
      }
    ]
  },
  {
    id: 'TK-2026-0039',
    titulo: 'Solicitação de reembolso de compra de pontos',
    descricao: 'Comprei 50.000 pontos por engano. Preciso do estorno no cartão utilizado.',
    tipo: 'reclamacao',
    status: 'aberto',
    prioridade: 'urgente',
    usuario_tipo: 'empresa',
    usuario_nome: 'Paulo Henrique',
    usuario_email: 'paulo@sistemasintegrados.com.br',
    responsavel: 'Carlos Mendes',
    data_criacao: '2026-05-08T08:00:00Z',
    data_atualizacao: '2026-05-08T08:00:00Z',
    respostas: []
  },
  {
    id: 'TK-2026-0038',
    titulo: 'Problema no login do aplicativo',
    descricao: 'O app trava na tela de login após digitar email e senha. Já reinstalei e o problema persiste.',
    tipo: 'suporte_tecnico',
    status: 'resolvido',
    prioridade: 'alta',
    usuario_tipo: 'participante',
    usuario_nome: 'Beatriz Santos',
    usuario_email: 'bia.santos@email.com',
    responsavel: 'Ana Souza',
    data_criacao: '2026-05-05T11:10:00Z',
    data_atualizacao: '2026-05-06T15:30:00Z',
    respostas: [
      {
        id: 'r-004',
        autor_nome: 'Ana Souza',
        autor_role: 'suporte',
        mensagem: 'Olá Beatriz! Identificamos um bug na última versão do app. Fizemos uma correção e liberação da versão 2.4.1. Por favor atualize e tente novamente.',
        data: '2026-05-06T15:30:00Z',
        interna: false
      }
    ]
  },
  {
    id: 'TK-2026-0037',
    titulo: 'Dúvida sobre regras de pontuação',
    descricao: 'Gostaria de entender melhor como funciona a pontuação por meta atingida vs pontuação por vendas diretas.',
    tipo: 'duvida',
    status: 'fechado',
    prioridade: 'baixa',
    usuario_tipo: 'empresa',
    usuario_nome: 'Luciana Almeida',
    usuario_email: 'luciana@empresaexemplo.com.br',
    responsavel: 'Mariana Lima',
    data_criacao: '2026-05-03T09:00:00Z',
    data_atualizacao: '2026-05-04T14:00:00Z',
    respostas: [
      {
        id: 'r-005',
        autor_nome: 'Mariana Lima',
        autor_role: 'operador',
        mensagem: 'Olá Luciana! Enviei um material completo sobre as regras de pontuação no seu email. Também disponibilizamos na área de treinamento.',
        data: '2026-05-04T14:00:00Z',
        interna: false
      }
    ]
  },
  {
    id: 'TK-2026-0036',
    titulo: 'Saque PIX atrasado há 3 dias',
    descricao: 'Solicitei resgate de R$ 450,00 no dia 02/05 e ainda não recebi na minha conta.',
    tipo: 'financeiro',
    status: 'aberto',
    prioridade: 'urgente',
    usuario_tipo: 'participante',
    usuario_nome: 'Roberto Dias',
    usuario_email: 'roberto.dias@email.com',
    responsavel: 'Carlos Mendes',
    data_criacao: '2026-05-08T07:30:00Z',
    data_atualizacao: '2026-05-08T07:30:00Z',
    respostas: []
  },
  {
    id: 'TK-2026-0035',
    titulo: 'Erro ao gerar relatório de performance',
    descricao: 'Ao clicar em "Exportar Relatório" recebo erro 500. Acontece com todos os relatórios.',
    tipo: 'suporte_tecnico',
    status: 'em_andamento',
    prioridade: 'alta',
    usuario_tipo: 'empresa',
    usuario_nome: 'Amanda Rocha',
    usuario_email: 'amanda@consultoratech.com.br',
    responsavel: 'Ana Souza',
    data_criacao: '2026-05-07T10:20:00Z',
    data_atualizacao: '2026-05-08T09:00:00Z',
    respostas: [
      {
        id: 'r-006',
        autor_nome: 'Ana Souza',
        autor_role: 'suporte',
        mensagem: 'Olá Amanda! Estamos investigando o problema no servidor de relatórios. Identificamos uma instabilidade que está sendo corrigida agora.',
        data: '2026-05-08T09:00:00Z',
        interna: false
      }
    ]
  }
];